import { defineMessage } from 'services/localization';

export const messages = {
    lockDateOverrideWarning: defineMessage('when_approved_the_date__date_is_set_as_lockdate'),
};
